import React from 'react';
import { useTranslation } from 'react-i18next';

const ConsoleLog: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('debug.console')}
      </h3>
      <div className="bg-gray-900 rounded p-3 text-xs font-mono text-green-400 overflow-auto max-h-48">
        <p className="text-gray-500">[--:--:--] Waiting for connection...</p>
      </div>
    </div>
  );
};

export default ConsoleLog;
